export const messages = {
    allDay: 'Todo el día',
    previous: '<',
    next: '>',
    today: 'Hoy',
    month: 'Mes',
    week: 'Semana',
    day: 'Día',
    agenda: 'Agenda',
    date: 'Fecha',
    time: 'Hora',
    event: 'Evento',
    noEventsInRange: 'No hay eventos en este rango',
    minDateMessage: 'La fecha no debe ser anterior a la fecha mínima',
    maxDateMessage: 'La fecha no debe ser posterior a la fecha máxima',
    showMore: total => `+ Ver más (${total})`
};